import { Controller } from "@hotwired/stimulus"
import PlacesAutocomplete from "stimulus-places-autocomplete"

window.initAutocomplete = function () {
  const event = new Event('google-maps-callback', {
    bubbles: true,
    cancelable: true,
  })

  window.dispatchEvent(event)
  window.initAutocompleteDone = true
}

// Connects to data-controller="location-select"
export default class extends PlacesAutocomplete {
  static targets = [ "inputdata", "name", "address" ]
  static values = {
    types: String
  }

  connect() {
    if (window.initAutocompleteDone) {
      this.initAutocomplete()
    }
    window.addEventListener("google-maps-callback", this.initAutocomplete.bind(this))

    this._onAddressInput = this._onAddressInput.bind(this)
    this._onAddressBlur  = this._onAddressBlur.bind(this)

    if (this.hasAddressTarget) {
      this.addressTarget.addEventListener('input', this._onAddressInput)
      this.addressTarget.addEventListener('blur', this._onAddressBlur)
    }
  }

  disconnect() {
    if (this.hasAddressTarget) {
      this.addressTarget.removeEventListener('input', this._onAddressInput)
      this.addressTarget.removeEventListener('blur', this._onAddressBlur)
    }
    window.removeEventListener("google-maps-callback", this.initAutocomplete.bind(this))
  }

  placeChanged() {
    super.placeChanged()

    const place = this.autocomplete.getPlace()
    if (this.hasInputdataTarget) this.inputdataTarget.value = JSON.stringify(place)
    if (this.hasNameTarget) this.nameTarget.value = this.addressTarget.value

    this._lastPlaceSelected = true

    const event = new Event('placeChanged', {
      bubbles: true,
      cancelable: true,
    })

    this.addressTarget.dispatchEvent(event)
  }

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.addressTarget, this.autocompleteOptions);
    this.autocomplete.setTypes([this.typesValue]);
    this.autocomplete.addListener("place_changed", this.placeChanged);
  }

  get autocompleteOptions() {
    return {
      fields: ["address_components", "geometry", "place_id"]
    }
  }

  clearHiddenFields() {
    if (this.hasInputdataTarget) this.inputdataTarget.value = ""
    if (this.hasNameTarget) this.nameTarget.value = ""
    // reset flag
    this._lastPlaceSelected = false

    // notify others (np. map controller) about clearing location
    if (this.hasAddressTarget) {
      this.addressTarget.dispatchEvent(new Event('locationCleared', { bubbles: true, cancelable: true }))
      this.addressTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  // clear other fields if location was cleared
  _onAddressInput() {
    if (!this.hasAddressTarget) return

    const val = this.addressTarget.value
    if (!val || val.trim() === "") {
      this.clearHiddenFields()
    } else {
      this._lastPlaceSelected = false
    }
  }

  // No correct place selected - clear
  _onAddressBlur() {
    if (!this.hasAddressTarget) return

    const val = this.addressTarget.value
    // already cleared
    if (!val || val.trim() === "") return

    // clear hidden fields if nothing selected
    const hasPlaceData = this.hasInputdataTarget && this.inputdataTarget.value && this.inputdataTarget.value.trim() !== ""
    if (!hasPlaceData || !this._lastPlaceSelected) {
      this.clearHiddenFields()
    }
  }
}
